import { isEmpty } from 'ramda';
export const generateProps = (tableInstance) => {
    const columns = tableInstance.allColumns.filter((col) => !col.isVirtualColumn);
    return {
        hiddenColumns: tableInstance.state.hiddenColumns || [],
        setHiddenColumns: tableInstance.setHiddenColumns,
        columnOrder: tableInstance.state.columnOrder,
        // @ts-ignore
        columns: columns,
        setColumnOrder: tableInstance.setColumnOrder
    };
};
export const compareByColumnName = (columnsMap) => (a, b) => {
    var _a;
    return (_a = columnsMap[a]) === null || _a === void 0 ? void 0 : _a.columnName.localeCompare(columnsMap[b].columnName);
};
export const resetToDefaultHendler = ({ orderedColumnIds, columnsMap, requiredPredicate, needCompareByColumnName, defaultColumnsMap, setColumnOrder, setHiddenColumns }) => {
    const { selectedIds, unselectedIds } = orderedColumnIds.reduce((acc, id) => {
        if (requiredPredicate(columnsMap[id])) {
            acc.selectedIds.push(id);
        }
        else {
            acc.unselectedIds.push(id);
        }
        return acc;
    }, { selectedIds: [], unselectedIds: [] });
    let selectedIdsSorted = selectedIds;
    if (needCompareByColumnName) {
        selectedIdsSorted = orderedColumnIds.filter((id) => !unselectedIds.includes(id));
        unselectedIds.sort(compareByColumnName(columnsMap));
    }
    if (!isEmpty(defaultColumnsMap)) {
        selectedIdsSorted.sort((a, b) => defaultColumnsMap[a].index - defaultColumnsMap[b].index);
    }
    setColumnOrder([...selectedIdsSorted, ...unselectedIds]);
    setHiddenColumns(unselectedIds);
};
